<template>
  <el-main>
    <div class="main__cruise-ticket container">
      <div class="suspend__card">
        <img src="../assets/svg/ic-alarm.svg" />
        <div class="suspend__card-body">
          <h1>{{ suspendedHeaderLabel }}</h1>
          <section>{{ suspendedInfoLabel }}</section>
          <div class="suspend__card-buttons--desktop">
            <el-button
              class="suspend__btns suspend__btns--contact button--tertiary"
              type="secondary"
              @click="onClickContact"
            >
              {{ contactUsLabel }}
            </el-button>
            <el-button
              class="suspend__btns suspend__btns--newBooking button--primary"
              type="primary"
              @click="onClickStartCheckin"
            >
              {{ startCheckingInLabel }}
            </el-button>
          </div>
          <div class="suspend__card-buttons--mobile">
            <el-button
              class="suspend__btns suspend__btns--newBooking button--primary"
              @click="onClickStartCheckin"
            >
              {{ startCheckingInLabel }}
            </el-button>
            <el-button
              class="suspend__btns suspend__btns--contact button--tertiary"
              @click="onClickContact"
            >
              {{ contactUsLabel }}
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CheckinSuspended",
  created() {
    gtag("set", "page_path", "/checkin-suspended");
    gtag("event", "page_path", {
      path: "/checkin-suspended",
    });
  },
  data() {
    return {
      suspendedHeaderLabel: "Check-in incomplete",
      suspendedInfoLabel:
        "The check-in process has been suspended because it took too long to complete. Please click below to continue checking in or contact the Aqua Expeditions' Reservations team for assistance.",
      contactUsLabel: "CONTACT US",
      startCheckingInLabel: "CHECK IN AGAIN",
    };
  },
  methods: {
    ...mapActions(["updateCurrentStep", "refreshToken"]),
    onClickContact() {
      location.href = `${process.env.MARKETING_SITE_FRONTEND_URL}/contact-us/`;
    },
    onClickStartCheckin() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/typography";
@import "../scss/color";

$sm: 360px;
$md: 720px;
$lg: 1200px;
.el-main {
  background-color: $aqua-grey-10;
  min-height: unset;
}

.suspend__card {
  margin: 80px 0 104px 0;
  /*margin-bottom: 56px;*/
  padding: 20px 12px;
  display: flex;
  flex-direction: row;
  gap: 16px;

  @media (min-width: $lg) {
    padding: 0 80px 56px 80px;
  }
  @media (min-width: $md) and (max-width: $lg - 1) {
    padding: 37px 0 100px 35px;
  }

  img {
    align-self: flex-start;
  }

  .suspend__card-body {
    display: flex;
    flex-direction: column;
  }

  h1 {
    color: $aqua-grey-100;
    @include global-paragraph-x-large-bold;
    margin-top: 0;
    margin-bottom: 16px;
  }

  section {
    color: $aqua-grey-100;
    @include global-paragraph-medium-regular;
    padding-bottom: 40px;
  }

  .suspend__btns {
    display: block;
    padding: 12px 32px;
    height: 56px;
    @include global-paragraph-medium-regular;
    @media (min-width: $lg) {
      display: inline-block;
    }
    @media (min-width: $md) and (max-width: $lg - 1) {
      display: inline-block;
    }
  }
}

.suspend__btns--contact {
  margin-left: 0;
}

.suspend__btns--newBooking {
  margin-left: 0;
  @media (min-width: $lg) {
    margin-left: 24px;
  }
  @media (min-width: $md) and (max-width: $lg - 1) {
    margin-left: 24px;
  }
}

.suspend__card-buttons--desktop {
  display: none;
  @media (min-width: $lg) {
    display: block;
  }
  @media (min-width: $md) and (max-width: $lg - 1) {
    display: block;
  }
}

.suspend__card-buttons--mobile {
  display: block;
  @media (min-width: $lg) {
    display: none;
  }
  @media (min-width: $md) and (max-width: $lg - 1) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CheckinSuspended.vue